<template>
  <div class="container">
    <div class="row">
      <div class="col-2 navbar-collapse sidebar">
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>
        <div class="head-page">
          <div class="page-title">
            <div class="title">
              <h1>Node tasks</h1>
            </div>
          </div>
          <div>
          </div>

          <router-link tag="button" class="btn btn-primary btn-lg" :to="{ name: 'NewNodeTask' }">
            <i class="vik vik-plus"></i>Add new
          </router-link>


        </div>
        <div class="card-cont">
          <VuePerfectScrollbar class="scroll-area card-list" :settings="{ wheelPropagation: false }"
            @ps-y-reach-end="scrollEnd" :style="{
              'height': filterSectionHeight - 250 + `px`,
            }">
            <router-link tag="div" v-for="item in filteredScopes" v-bind:key="item.id"
              :to="{ name: 'SingleScope', params: { id: item.id } }"
              v-bind:class="{ active: item.id == $route.params.id }" class="card">
              <div class="card-char rounded-circle" style>
                {{ firstLetter(item.name) }}
              </div>
              <div class="card-body">
                <h5 class="card-title">{{ shorted(item.name) }}</h5>
                <span class="card-info">assets: {{ item.count }}</span>
              </div>
            </router-link>
          </VuePerfectScrollbar>
        </div>
      </div>
      <div class="col">
        <div class="content">
          <div>
            <div class="head-item">
              <!--шапка таргета-->

              <!-- end of head -->
              <div class="filtering">
                <div class="filter-control">
                  <div class="dop-options">
                    <div class="checkbox-label" style>
                      <label class="checkbox">
                        <input type="checkbox" />
                        <span>Select all</span>
                      </label>
                    </div>
                    <div>
                      <button @click="onCollapseAll" title="collapse all" class="btn-sm btn-link">
                        <i class="vik vik-collapse"></i>collapse
                      </button>
                      <button @click="onExpandAll" title="expand all" class="btn-sm btn-link">
                        <i class="vik vik-expand"></i>expand
                      </button>
                    </div>
                  </div>

                </div>

                <div class="search-block">
                  <div class="dual-input-group">
                    <div class="search-input">
                      <div class="input-icon">
                        <i class="vik vik-search"></i>
                      </div>
                      <input v-model="filterValue" type="text" class="form-control" placeholder="filter" />
                    </div>
                    <el-select v-model="filterField" placeholder="Filter">
                      <el-option value="Host">Host</el-option>
                      <el-option :key="field" v-for="field in assetsFields" :value="field">{{
                        field }}</el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-container" v-for="node in nodes" :key="node.task_id">
              <div class="resource-list">
                <div class="resource-item" v-bind:class="{
                  colapsed: isCollapsed(node.task_id),
                  active: isSelected(node.task_id),
                }">
                  <div class="head-resourse">
                    <div class="checkbox-label">
                      <label class="checkbox">
                        <input type="checkbox" :value="node" />
                        <span>{{ node.name }}
                        </span>
                        <router-link v-if="$route.params.id == '*'" class="el-badge item" tag="div"
                          :to="{ name: 'SingleScope', params: { id: node.task_id } }">
                          <sup class="el-badge__content el-badge__content--undefined"
                            style="background: #dae1e3; cursor: pointer;">{{
                              node.name }}</sup>
                        </router-link>
                      </label>


                    </div>
                    <!-- short view -->
                    <div class="collapse-cont" v-if="isCollapsed(node.task_id)">
                      <div class="value" v-for="titleItem in computedTitles" :key="titleItem.key">
                        {{ titleItem.title }}
                        <span>{{ index(node, titleItem.key) }}</span>
                      </div>
                    </div>

                    <div class="control ml-auto">
                      <button class="btn btn-sm btn-more" type="button" @click="onRestart(node.task_id)"
                        title="Restart task">
                        <i class="el-icon-refresh-right"></i>
                      </button>
                      <button class="btn btn-sm btn-collapse" type="button" @click="toggleCollapse(node.task_id)"
                        v-bind:class="{ collapsed: isCollapsed(node.task_id) }">
                        <i class="vik vik-up"></i>
                      </button>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="resourse-cont" v-if="!isCollapsed(node.task_id)">
                      <div v-for="title in computedTitles" class="resource-value" :key="title.key">
                        <TargetColumnRender :value="JSON.stringify(node)" :column="title.key" :key="title.key">
                        </TargetColumnRender>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <el-drawer title="Cloud sync" size="25%" direction="rtl" :append-to-body="true"
      :visible.sync="exportToCloudDialogVisible">

    </el-drawer>


  </div>
</template>
<script>
import { bus } from "@/bus.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import * as utils from "@/utils";
import { getNodeTasks } from "@/api.js";
import _ from "lodash";
import TargetColumnRender from "@/components/internal/TargetColumnRenderV2.vue";


export default {
  components: { VuePerfectScrollbar, TargetColumnRender },
  data() {
    return {
      nodes: [],
      assetsFields: ["IP", "Name"],
      filterField: "IP",
      editMode: false,
      collapsed: [],
      selectedTargets: [],

      filterValue: "",
      windowHeight: window.innerHeight,
      scopes: [],
      scopesFilter: "",
      noMore: false,
      loading: false,
      total_scopes: 0,
      exportToCloudDialogVisible: false,
      newScopeName: "",
      newAssetsModalVisible: false,
      editMode: false,
      overTitle: false,
      assets: [],
      name: "",
      assetsPerPage: 10,
      pageNum: 1,
      loading: false,
      deleting: false,
      assetsAreDeleting: false,
      totalRows: 0,
      imported: 0,
      list_name: "-",
      percent: 0,
      interval: 0,

    };
  },
  watch: {
    // $route(to, from) {
    //     // console.log("changed", to);
    // },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    bus.$on("refresh-scopes", () => {
      this.load(true)
    });
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.load().then(() => {
    });
    // this.loadTotalTargets();

  },
  computed: {
    computedTitles() {
      return [{ title: "Asset", key: "asset.host" }, { title: "Status", key: "status" }, { title: "Created", key: "created_at" }];
      return this.titles.filter((record) => {
        return record.key.toLowerCase() != "host";
      });
    },
    filterSectionHeight() {
      return this.windowHeight;
      const filterSectionDOM = document.getElementById("search-group");
      return filterSectionDOM ? filterSectionDOM.offsetHeight : 0;
    },
    filteredScopes() {
      return this.scopes;

    },
    disabled() {
      return this.loading || this.noMore;
    },
    showAll: {
      // getter
      get: function () {
        return this.$route.params.id == "*";
      },
      // setter
      set: function (newValue) {
        if (newValue === true) {
          this.$router.replace({
            name: "SingleScope",
            params: {
              id: "*",
            },
          });
        }
        return;
      },
    },

  },
  methods: {
    onRestart(taskID) {
      utils.$post(`/api/nodes/tasks/restart/`, { task_id: taskID }).then((data) => {
        this.load(true);
      });
    },
    index(obj, is, value) {
      if (typeof is == 'string')
        return this.index(obj, is.split('.'), value);
      else if (is.length == 1 && value !== undefined)
        return obj[is[0]] = value;
      else if (is.length == 0)
        return obj;
      else
        return this.index(obj[is[0]], is.slice(1), value);
    },
    onCollapseAll() {
      this.collapseState = "collapsed";
      this.onCollapseAllChange();
    },
    onExpandAll() {
      this.collapseState = "expanded";
      this.onCollapseAllChange();
    },

    onCollapseAllChange() {
      if (this.collapseState == "collapsed") {
        this.nodes.forEach((node) => {
          if (!this.collapsed.includes(node.task_id)) {
            this.collapsed.push(node.task_id);
          }
        });
      }
      if (this.collapseState == "expanded") {
        this.nodes.forEach((node) => {
          var index = this.collapsed.indexOf(node.task_id);
          if (index !== -1) {
            this.collapsed.splice(index, 1);
          }
        });
      }
    },
    onSelectAllChange() {
      if (this.selectAll) {
        this.nodes.forEach((node) => {
          if (!this.selectedTargets.some((t) => t.host === node.task_id)) {
            this.selectedTargets.push(node);
          }
        });
      } else {
        this.selectedTargets = [];
      }
    },
    toggleCollapse(domain) {
      if (this.collapsed.includes(domain)) {
        this.collapseAll = "";
        this.collapsed = this.collapsed.filter((item) => item !== domain);
      } else {
        this.collapsed.push(domain);
      }
    },
    isCollapsed(k) {
      return this.collapsed.includes(k);
    },
    isSelected(domain) {
      return this.selectedTargets.some((t) => t.domain === domain);
    },
    exportToCloudShowDialog() {
      this.exportToCloudDialogVisible = true
    },

    onResize() {
      this.windowHeight = window.innerHeight
    },
    shorted(s) {
      if (s.length > 19) return s.substring(0, 17) + "...";
      return s;
    },
    firstLetter(s) {
      return s.length > 0 ? s[0] : s;
    },
    scrollEnd() {
      if (!this.loading) {
        if (this.scopes.length > 5) this.load(false);
      }
    },

    onInputChange: _.throttle(function () {
      this.load(true);
    }, 1500),

    async load(reset) {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
        "is-full-page": true,
        color: "#BDCDD0",
        loader: "dots",
      });


      this.loading = true;
      let that = this;
      if (reset) {
        this.nodes = [];
      }
      return getNodeTasks(
        utils.objectToString({
          offset: this.nodes.length,
          q: this.scopesFilter,
        })
      ).then((data) => {
        loader.hide()
        this.loading = false
        for (var s of data.Records) {
          that.nodes.push(s);
          that.collapsed.push(s.task_id)
        }
      });
    },
    onShowAllChange() { },
  },
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  min-height: 300px;
}

@media only screen and (min-width: 0) and (max-width: 1023px) {
  .scroll-area {
    height: 400px;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 4096px) {
  /* .scroll-area {
        height: 500px;
      } */
}

.nintenpercent {
  width: 95%;
}

.badger {
  margin-top: -20px;
}

.el-badge__content {
  border-radius: 10px;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  padding: 0 5px;
  background: #9bc7f5;
}

.tb {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/pages/NodeTasks.vue